import { plugins, request } from '@gameforge/http-client'
import { eventBridge } from './eventBridge'
import { interceptChallenges } from './interceptChallenges'

export const apiClient = request(`${window.origin}/api`)
  .use(interceptChallenges())
  .use(eventBridge)
  .use(plugins.throwOnStatus(400))
